import React, { Component } from 'react';
import SharedFeedsTable from './SharedFeedsTable';
import InfoCircle from "../../common/InfoCircle";

class SharedTablesManage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sortColumn: {
                path: "name",
                order: "asc"
            }
        };
    }

    handlePageChange = page => {
        this.setState({currentPage: page})
    };

    handleSort = (sortColumn) => {
        this.setState({sortColumn})
    };

    render() {
        const { feeds } = this.props;
        return (
            <div className="team-card panel-container m-m-b feeds-shared">
                <div className="team-header">
                    <h3>Workspaces Shared With Me
                        <InfoCircle
                            icon='question'
                            infoCircleContent={
                                <p className='info-circle-content' ><strong>Workspaces Shared With Me</strong> <br/>
                                    You are the workspace admin for all workspaces in this section.</p>
                            }
                        />
                    </h3>
                </div>
                <div className="team-body">
                    <SharedFeedsTable feeds={feeds}
                                      sortColumn={this.state.sortColumn}
                                      onClick={this.handleClick}
                                      onSort={this.handleSort}
                                      openModal={this.props.openModal}/>
                </div>
            </div>
        );
    }
}

export default SharedTablesManage